/** Per-workload usage: blocked until a specific Graph scope is granted.
 *
 *  The panel names the missing scope verbatim, because "permission denied" is
 *  a ticket that bounces and "grant Reports.Read.All with admin consent" is a
 *  ticket that gets actioned. */

import { FileWarning, Icon } from "@norican/icons";
import { Card, EmptyState, Typography } from "@norican/react";

import type { UsageReportStatus } from "@/lib/api";

interface UsageReportPanelProps {
  status: UsageReportStatus;
}

export function UsageReportPanel({ status }: UsageReportPanelProps) {
  if (status.available) {
    return null;
  }

  return (
    <Card variant="outline">
      <Card.Header>
        <Typography variant="heading-4" as="h2">
          Workload usage
        </Typography>
      </Card.Header>
      <Card.Body>
        <EmptyState
          size="sm"
          icon={<Icon icon={FileWarning} size="lg" tone="warning" />}
          title={
            status.missing_scope
              ? `Blocked — ${status.missing_scope} is not granted`
              : "Workload usage is unavailable"
          }
          description={status.detail}
        />
      </Card.Body>
    </Card>
  );
}
